module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./SubAccountView.js"));
	}, "SubAccountView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=SubAccountView!./src/pages/Store/InfoManage/SubAccount/SubAccountView.js
// module id = 2152
// module chunks = 367